import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const passwordMatchValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const newPassword = control.get('new_password')?.value;
  const confirmPassword = control.get('confirm_password')?.value;

  if (!newPassword || !confirmPassword) return null;

  return newPassword === confirmPassword ? null : { passwordMismatch: true };
};